/**
 * @author: lv.chen
 * @desc: ManufacturerChanged厂商异动
 * @date: 2025/12/15
 */
import React from 'react';
import classnames from 'classnames';
import { getSanitizeHTMLString } from '@intelligence/v3/utils/common';
import { CasualDailyReportData } from '@intelligence/v3/pages/CasualDailyReports/utils';

import IMG_TITLE_MARKET from '@intelligence/assets/imgs/casualDailyReports/title-market.png';

interface IManufacturerChangedProps extends IBaseProps {
  markdownConverter: React.MutableRefObject<CasualDailyReportData>;
  renderLinker: any;
  manufacturerChanged?: IManufacturerChange[] | null;
}

const ManufacturerChanged: React.FC<IManufacturerChangedProps> = (props) => {
  const { style, className, markdownConverter, renderLinker, manufacturerChanged } = props;
  const manufacturerChangedLength = manufacturerChanged?.length || 0;

  return (
    <div
      style={style}
      className={classnames('dbi-section-market dbi-casual-daily-reports-manufacturer-changed', className, {
        'dbi--more': manufacturerChangedLength > 1,
      })}
    >
      <div className="dbi-section-market-title">
        <img className="dbi-section-market-title-img" src={IMG_TITLE_MARKET} alt="市场动态" />
      </div>
      <div className="dbi-section-market-list">
        {manufacturerChanged?.map((item, index) => {
          const itemCompanyName = item?.company_name || '';
          const itemCover = item?.cover || '';
          const itemNewsCover = item?.news_cover || '';
          const itemIsSpecial = item?.is_special || false;

          return (
            <div
              key={index}
              className={classnames('dbi-market-update-card', {
                'dbi-market-update-card--special': !itemCover && itemIsSpecial,
              })}
            >
              {itemIsSpecial && <i className="dbi-icon-featured"></i>}
              <div className="dbi-market-card-content">
                {itemCompanyName && (
                  <div className="dbi-market-company-info">
                    {itemCover && <img className="dbi-market-logo" src={itemCover} alt="logo" />}
                    <div className="dbi-market-info-span">
                      <div className="dbi-market-name">{itemCompanyName}</div>
                      <div className="dbi-market-region">{item?.company_region}</div>
                    </div>
                  </div>
                )}
                <div className="dbi-market-news-title">{item?.title}</div>
                <div
                  className="dbi-market-news-description"
                  dangerouslySetInnerHTML={{
                    __html: markdownConverter.current.convertMarkdownToHTMLWithStyle(
                      getSanitizeHTMLString(item?.abstract) || '',
                      {
                        h3: '',
                        ul: '',
                        li: '',
                      },
                    ),
                  }}
                ></div>
                {itemNewsCover && <img className="dbi-market-news-img" src={itemNewsCover} alt="news" />}
                {renderLinker(item)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ManufacturerChanged;
